import createReactComponent from '../createReactComponent';
export default createReactComponent('terminal', 'IconTerminal', [
  ['path', { d: 'M5 7l5 5l-5 5', key: 'svg-0' }],
  ['path', { d: 'M12 19l7 0', key: 'svg-1' }],
]);
